import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getAll() {
  const response = await http
    .getData(`/referensi/dokter-simrs`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getAll,
};
